import React from 'react';

function HistoryDetail() {
  return <div>HistoryDetail</div>;
}

export default HistoryDetail;
